import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@cgn/framework-ui-components/v2';
import useRequiredField from './useRequiredField';

const inputProps = {
  maxLength: 80,
};

export default function Oggetto({ value, onChange }) {
  const {
    text, state, stateMessage, onChange: handleOnChange,
  } = useRequiredField(value, onChange);

  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <TextField
      ref={inputRef}
      value={text}
      disabled={!onChange}
      className="helpdesk-frontend-scelta-servizio__form-item helpdesk-frontend-questionario__oggetto"
      title="Oggetto (massimo 80 caratteri)*"
      onChange={handleOnChange}
      inputProps={inputProps}
      state={state}
      stateMessage={stateMessage}
    />
  );
}

Oggetto.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};
Oggetto.defaultProps = {
  onChange: undefined,
};
